export const checkIsPositiveValue = (value: string) => {
  return parseInt(value, 10) >= 0
}

export const checkIsNegativeValue = (value: string) => {
  return parseInt(value, 10) < 0
}
